import _ from "lodash";

/**
 * Genera tarifas y honorarios por profesional y liquidación.
 * @param {Array} asistencias
 * @param {Array} legajos
 * @param {Array} gastos
 * @param {number|string} idLiquidacion
 * @returns {Array<{ idUsuario:number, idLiquidacion:number|string, monto:number, tarifaProfesional:number }>}
 */
export const generarProfesionalesPorLiquidacion = (
  asistencias,
  legajos,
  gastos,
  idLiquidacion,
  NombrePaciente
) => {
  const registros = [];
  // 🔹 Asistencias
  asistencias
    .filter(
      (a) =>
        a.asignado &&
        (a.parahonorario?.toUpperCase() === "SI" ||
          a.paratarifa?.toUpperCase() === "SI")
    )
    .forEach((a) => {
      registros.push({
        idUsuario: a.asignado,
        idLiquidacion,
        NombrePaciente,
        monto:
          a.parahonorario?.toUpperCase() === "SI"
            ? Number(a.honorario) || 0
            : 0,
        tarifa:
          a.paratarifa?.toUpperCase() === "SI" ? Number(a.tarifa) || 0 : 0,
        incluyeHonorario: a.parahonorario?.toUpperCase() === "SI",
      });
    });

  // 🔹 Legajos
  legajos
    .filter(
      (l) =>
        l.IdUsuario &&
        (l.paraHonorario?.toUpperCase() === "SI" ||
          l.paraTarifa?.toUpperCase() === "SI")
    )
    .forEach((l) => {
      const horas =
        Number(Number(l.horashoraextra || 0).toFixed(2)) +
        Number(l.horascalculadas || 0);
      const horasFeriado = Number(l.horasferiado || 0);
      const porcentajeFeriado = Number(l.porcentajeferiado || 0);
      const calcularMonto = (costo) =>
        Number(costo || 0) * horas +
        (Number(costo || 0) * horasFeriado * porcentajeFeriado) / 100;

      registros.push({
        idUsuario: l.IdUsuario,
        idLiquidacion,
        NombrePaciente,
        monto:
          l.paraHonorario?.toUpperCase() === "SI"
            ? Math.round(calcularMonto(l.CostoHoraProfesional))
            : 0,
        tarifa:
          l.paraTarifa?.toUpperCase() === "SI"
            ? Math.round(calcularMonto(l.CostoHoraEmpresa))
            : 0,
        incluyeHonorario: l.paraHonorario?.toUpperCase() === "SI",
      });
    });

  // 🔹 Gastos asociados al profesional: solo se incorporan a la tarifa aquí.
  // Los honorarios de gastos se agregan luego en Profesionales para no duplicarlos.
  gastos
    .filter((g) => g.idUsuario && g.paraTarifa?.toUpperCase() === "SI")
    .forEach((g) => {
      registros.push({
        idUsuario: g.idUsuario,
        idLiquidacion,
        NombrePaciente,
        monto: 0,
        tarifa: Number(g.monto) || 0,
        incluyeHonorario: false,
      });
    });

  // 🔹 Agrupar por (profesional + liquidación)
  const agrupados = _(registros)
    .groupBy((r) => `${r.idUsuario}_${r.idLiquidacion}`)
    .filter((items) => items.some((item) => item.incluyeHonorario))
    .map((items) => ({
      idUsuario: items[0].idUsuario,
      NombrePaciente,
      idLiquidacion: items[0].idLiquidacion,
      monto: _.sumBy(items, "monto"),
      tarifaProfesional: Math.round(_.sumBy(items, "tarifa")),
    }))
    .value();

  return agrupados;
};
